<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <nuxt-link :to="localePath('office-products')">
            {{ $t("page.products") }}
          </nuxt-link>
        </li>

        <li class="is-active">
          <a aria-current="page">{{ $t("form.metal") }}</a>
        </li>
      </ul>
    </nav>
    <div class="columns">
      <div class="column">
        <nuxt-link
          :to="localePath('office-products-metal-metal-posts')"
          class="box"
        >
          <p class="title is-5">{{ $t("page.metal_posts") }}</p>
        </nuxt-link>
      </div>
      <div class="column">
        <nuxt-link
          :to="localePath('office-products-metal-metal-clamps')"
          class="box"
        >
          <p class="title is-5">{{ $t("page.metal_clamps") }}</p>
        </nuxt-link>
      </div>
      <div class="column">
        <nuxt-link
          :to="localePath('office-products-metal-hand-sanitizer')"
          class="box"
        >
          <p class="title is-5">{{ $t("page.hand_sanitizer") }}</p>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  scrollToTop: true,
  watchQuery: true,
};
</script>




// WEBPACK FOOTER //
// resources/nuxt/pages/office/products/metal/index.vue